import { useEffect, useState } from "react";
import s from "./AccessoriesToast.module.css";

export default function AccessoriesToast({
  open,
  message,
  onClose,
  autoHideDuration = 2500,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      // Delay to trigger CSS transition
      const frame = requestAnimationFrame(() => setVisible(true));
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onClose?.(), 300);
      }, autoHideDuration);

      return () => {
        cancelAnimationFrame(frame);
        clearTimeout(timer);
      };
    }
    setVisible(false);
  }, [open, autoHideDuration, onClose]);

  if (!open) return null;

  return (
    <div
      className={`${s.toast} ${visible ? s.show : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className={s.check}>
        <svg
          viewBox="0 0 10 10"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M2 5 L4 7 L8 3" />
        </svg>
      </span>
      <span>{message}</span>
    </div>
  );
}
